import { DIFFICULTIES } from "../../config";
import { LCD } from "../../config";
import type { GameSettings } from "../../ui/settings";
import { drawText, type DrawContext } from "../text";
import { isBlinking } from "./titleView";

interface MenuItem {
  name: string;
  value: (settings: GameSettings) => string | null;
}

const ITEMS: readonly MenuItem[] = [
  { name: "ZORLUK", value: (s) => DIFFICULTIES[s.difficultyIndex].label },
  { name: "DUVAR GECISI", value: (s) => (s.wallPass ? "ACIK" : "KAPALI") },
  { name: "HIZ MODU", value: (s) => (s.progressive ? "KADEMELI" : "SABIT") },
  { name: "SES", value: (s) => (s.sound ? "ACIK" : "KAPALI") },
  { name: "OYUNA BASLA", value: () => null },
];

export function drawSettings(rc: DrawContext, settings: GameSettings, menuIndex: number): void {
  const { width, height } = rc.layout;
  const fs = Math.max(10, Math.floor(rc.layout.cell * 0.55 * 1.4));
  const lineH = fs * 2.4;
  const topY = height * 0.3;

  drawText(rc, "OYUN AYARLARI", width / 2, height * 0.13, Math.floor(fs * 1.2));

  for (let i = 0; i < ITEMS.length; i++) {
    const item = ITEMS[i];
    const y = topY + i * lineH;
    const selected = i === menuIndex;
    const color = selected ? LCD.dark : "rgba(32, 48, 26, 0.65)";

    if (selected) drawText(rc, ">", width * 0.22, y, fs, "left");
    drawText(rc, item.name, width * 0.5 - fs * 1.5, y, fs, "right", color);

    const value = item.value(settings);
    if (value) {
      drawText(rc, `< ${value} >`, width * 0.5 + fs * 1.5, y, fs, "left", color);
    } else if (selected && isBlinking(1.5)) {
      drawText(rc, "[ BASLA ]", width * 0.5 + fs * 1.5, y, fs, "left");
    }
  }

  drawText(rc, "SES: M   GERI: B/ESC   F: TAM EKRAN", width / 2, height * 0.94, Math.floor(fs * 0.7));
}
